import PropTypes from 'prop-types'
import { useState } from 'react'

import { MODAL_MODE } from '../helpers'

import ApartmentsConnectionModal from './ApartmentsConnectionModal'
import Connections from './Connections'
import Locations from './Locations'

const SettingsModal = ({ buildingId, mode = MODAL_MODE.CONNECTIONS, onClose, onConnected }) => {
  const [currentMode, setCurrentMode] = useState(mode)

  return (
    <div className="reputation-management-page__settings--wrap">
      {currentMode === MODAL_MODE.CONNECTIONS && (
        <Connections
          buildingId={buildingId}
          onNext={(mode) => {
            setCurrentMode(mode)
          }}
          onClose={onClose}
          onConnected={onConnected}
        />
      )}
      {currentMode === MODAL_MODE.LOCATIONS && (
        <Locations
          buildingId={buildingId}
          onBack={() => setCurrentMode(MODAL_MODE.CONNECTIONS)}
          onClose={onClose}
          onConnected={onConnected}
        />
      )}
      {currentMode === MODAL_MODE.APARTMENTS && (
        <ApartmentsConnectionModal
          buildingId={buildingId}
          onBack={() => setCurrentMode(MODAL_MODE.CONNECTIONS)}
          onClose={onClose}
          onConnected={onConnected}
        />
      )}
    </div>
  )
}

SettingsModal.propTypes = {
  buildingId: PropTypes.number,
  mode: PropTypes.oneOf(Object.values(MODAL_MODE)),
  onClose: PropTypes.func,
  onConnected: PropTypes.func,
}

export default SettingsModal
